import script from "./EventSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSidebar.vue?vue&type=script&setup=true&lang=js"

import "./EventSidebar.vue?vue&type=style&index=0&id=54a776fb&scoped=true&lang=css"
import "./EventSidebar.vue?vue&type=style&index=1&id=54a776fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a776fb"]])

export default __exports__